import React from 'react';

const SignUpPage = () => {
  return <p>OLB Sign Up Not Yet Supported</p>;
};

export default SignUpPage;
